/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Password_InstructionsInputs */

const en_auth__password_instructions = /** @type {(inputs: Auth__Password_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 8 characters, one uppercase letter, one lowercase letter, one number and one special character`)
};

/**
* | output |
* | --- |
* | "At least 8 characters, one uppercase letter, one lowercase letter, one number and one special character" |
*
* @param {Auth__Password_InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__password_instructions = /** @type {((inputs?: Auth__Password_InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Password_InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__password_instructions(inputs)
});